import { Component, Input, SimpleChanges } from '@angular/core';
import { faStar, faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LoginComponent } from '../modals/login/login.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-content-reviews',
  templateUrl: './content-reviews.component.html',
  styleUrls: ['./content-reviews.component.scss']
})
export class ContentReviewsComponent {
  @Input() comments: any[] = [];
  @Input() message: any;
  @Input() redirect?: any =false;
  @Input() showFullText: boolean = false;
  maxLength: number = 200;
  isLoggedIn: boolean;
  modalLogin?: NgbModalRef;
  ngbModalOptions: NgbModalOptions = {
    backdropClass: 'modal-backdrop-blur',
    backdrop: 'static',
    keyboard: false,
    centered: true,
  };


  // Variables para paginación
  allPaginator: any[] = []; // Copia de todos los comentarios
  displayedComments: any[] = []; // Comentarios a mostrar

  faStarRegular = faStar;
  faThumbsUp = faThumbsUp;

  constructor(
    private authService: AuthService,
    private router: Router,
    private modalService: NgbModal,
  ) { }

  displayText(review: any): string {
    if (!review?.comment) return '';
    if (this.showFullText || review.comment.length <= this.maxLength) {
      return review.comment;
    }
    return review.comment.substring(0, this.maxLength) + '...';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['comments']) {
      this.allPaginator = [...this.comments]; // Hacemos copia del array
      this.displayedComments = this.allPaginator.slice(0, 10); // Mostramos primeros 10 inicialmente
    }
  }

  onPageDataChange(event: { items: any[], currentPage: number, totalPages: number }): void {
    this.displayedComments = event.items;
  }

  shouldShowToggle(review: any): boolean {
    return review?.comment && review.comment.length > this.maxLength;
  }

  toggleText() {
    this.showFullText = !this.showFullText;
  }

  toggleLike(review: any): void {
    const user = this.authService.getUserData();
    if (user != null) {
      const wasLiked = review.userLike;  // Cambiamos de isLikedByUser a userLike
      console.log(review);

      // Actualización optimista de la UI
      review.userLike = !wasLiked;  // Actualizamos el nuevo campo
      review.like = wasLiked ? (review.like - 1) : (review.like + 1);

      // Llamada al servicio
      const action = wasLiked ? 'remove' : 'add';
      this.authService.toggleLike(review.id, action).subscribe({
        next: (response) => {
          console.log('Like actualizado', response);
          // Opcional: Actualizar con datos reales del backend si es necesario
          // review.userLike = response.newLikeStatus;
          // review.like = response.newLikeCount;
        },
        error: (error) => {
          console.error('Error al actualizar like', error);
          // Revertir cambios en caso de error
          review.userLike = wasLiked;
          review.like = wasLiked ? (review.like + 1) : (review.like - 1);
        }
      });

    } else {
      this.loogin();
    }
  }

  loogin() {
    this.modalLogin = this.modalService.open(
      LoginComponent,
      this.ngbModalOptions
    );
  }

}
